:host {
  display: inline-flex;
  place-content: center;
  aspect-ratio: 1 / 1;
  width: fit-content;
  max-width: fit-content;
  max-height: fit-content;
  font-size: wink-rem(1);

  i {
    display: inline-block;
    font-size: wink-rem(2.4);
    color: var(--wink-icon-color, var(--semantic-color-icon-default));
    text-align: center;

    &::before {
      display: block;
    }

    &.primary {
      color: var(--wink-icon-color, var(--semantic-components-icon-color-icon-primary));
      background-color: var(--wink-icon-bg-color, var(--semantic-components-icon-color-background-surface-primary));
    }

    &.secondary {
      color: var(--wink-icon-color, var(--semantic-components-icon-color-icon-subtle));
      background-color: var(--wink-icon-bg-color, var(--semantic-components-icon-color-background-surface-secondary));
    }

    &.transparent {
      color: var(--wink-icon-color, var(--semantic-components-icon-color-icon-primary));
      background-color: var(--wink-icon-bg-color, var(--semantic-components-icon-color-background-surface-transparent));
    }

    &.sm {
      width: var-rem(--semantic-icon-sm);
      font-size: var-rem(--semantic-icon-sm);
    }

    &.md {
      width: var(--wink-icon-size-md, var-rem(--semantic-icon-md));
      font-size: var(--wink-icon-size-md, var-rem(--semantic-icon-md));
    }

    &.lg {
      width: var-rem(--semantic-icon-lg);
      font-size: var-rem(--semantic-icon-lg);
    }

    &.xl {
      width: var-rem(--semantic-icon-xl);
      font-size: var-rem(--semantic-icon-xl);
    }

    &.color--default {
      --wink-icon-color: var(--semantic-color-icon-default);
    }

    &.color--subtle {
      --wink-icon-color: var(--semantic-color-icon-subtle);
    }

    &.color--subtlest {
      --wink-icon-color: var(--semantic-color-icon-subtlest);
    }

    &.color--inverse {
      --wink-icon-color: var(--semantic-color-icon-inverse);
    }

    &.color--promo {
      --wink-icon-color: var(--semantic-color-icon-promo);
    }

    &.backdrop {
      mask: var(--icon-component--backdrop);
      mask-repeat: no-repeat;
      mask-size: contain;

      &.sm {
        padding: var(--wink-icon-sm-padding, var-rem(--semantic-spacing-3xs));
      }

      &.md {
        padding: var(--wink-icon-md-padding, var-rem(--semantic-spacing-xs));
      }

      &.lg {
        padding: var-rem(--semantic-spacing-xs);
      }

      &.xl {
        padding: var-rem(--semantic-spacing-xs);

        @include media('from-sm') {
          padding: var-rem(--semantic-spacing-md);
        }
      }
    }
  }
}

:host([tabindex='0']) {
  cursor: pointer;
}

:host([tabindex='0']:focus) {
  @include state-focus-outline;
}
